// #region imports

// --- HS Code
import { JournalEntryTypes } from './journal-entry-types';

// #endregion

export interface JournalEntryModel {
  dateLastModified: Date;
  entryText: string | null | undefined;
  entryType: JournalEntryTypes;
  id: string | null;
  isImportant: boolean;
  pinLocation: string | null | undefined;
  resourceKey: string | null | undefined;
  styleId: number;
}
